import getCycleCardImagePath from "../utils/get-cycle-card-image-path";
import ImgComponent from "./ImgComponent";
import SvgIcon from "./SvgIcon";

/**
 * Reusable card for displaying a team (image, name, optional subtitle).
 * Same layout everywhere: row with image, then title + subtitle.
 */
const TeamCard = ({ team, subtitle = "Team Member", className = "" }) => {
  if (!team) return null;

  const image = getCycleCardImagePath(team);

  const imageClassNames = image.startsWith("data:image") ? "no-image" : "";

  return (
    <article className={`team-card ${className}`.trim()}>
      <div className="max-w-[66px]">
        <ImgComponent
          image={image}
          classNames={imageClassNames}
          altText="team thumbnail"
        />
      </div>
      <div>
        <h4 className="text-lg">{team?.name}</h4>
        <div className="flex items-center gap-2">
          <SvgIcon
            src="/img/new-icons/team-member.svg"
            noFilterOnLight={true}
          />
          <p>{subtitle}</p>
        </div>
      </div>
    </article>
  );
};

export default TeamCard;
